<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row mb-3">
                <div
                  class="col-8 d-flex mb-3 mb-lg-0 d-flex align-items-center"
                >
                  <router-link
                    :to="{ name: 'AddUser' }"
                    class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                  >+ {{ translations.addUser }}
                  </router-link>

                  <treeselect
                    v-model="b2bOrb2c"
                    class="w-25 mx-1 custom-vue-tree-select"
                    :options="b2bOrb2cOptions"
                    placeholder="B2B/B2C"
                  />
                  <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                  </div>
                  <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                    <div
                      class="d-flex align-items-lg-center flex-column flex-lg-row"
                    >
                      <select
                        class="form-control select-style-1 results-per-page"
                        name="results-per-page"
                        v-model="searchConfig.pageSize"
                        @change="changePageSize(searchConfig.pageSize)"
                      >
                        <option
                          :value="page"
                          v-for="page in pageSizeList"
                          :key="page"
                        >{{ page }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="datatable-ecommerce-list_wrapper"
              class="dataTables_wrapper dt-bootstrap5 no-footer"
            >
              <div class="row justify-content-between">
                <div class="col-auto"></div>
                <div class="col-auto"></div>
              </div>
              <div class="table-responsive" v-if="list.length > 0">
                <table
                  class="
                    table table-ecommerce-simple table-striped
                    mb-0
                    dataTable
                    no-footer
                  "
                  id="datatable-ecommerce-list"
                  style="min-width: 750px"
                  role="grid"
                  aria-describedby="datatable-ecommerce-list_info"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th class="sorting">
                        Ime i prezime
                      </th>
                      <th class="sorting">
                        Kompanija
                      </th>
                      <th class="sorting">
                        Telefon
                      </th>
                      <th class="sorting">
                        E-mail
                      </th>
                      <th class="sorting">
                        Korisničko ime
                      </th>
                      <th class="sorting">
                        Grad
                      </th>
                      <th class="sorting">
                        Aktivan?
                      </th>
                      <th class="sorting">
                        Datum kreiranja
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in list" 
                    @click="openDetails(user.id)"
                    :key="user.id" :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }">
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="user.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                          <strong>{{ `${user.firstName} ${user.lastName}` }}</strong>
                      </td>
                      <td>
                        {{ user.companyTitle }}
                      </td>
                      <td>{{ user.phoneNumber }}</td>
                      <td>{{ user.email }}</td>
                      <td>{{ user.userName }}</td>
                      <td>{{ user.town }}</td>
                      <td>
                        <span
                          class="badge text-2"
                          :class="{
                            'text-success bg-soft-success': user.isAccountApproved && user.isAccountVerified,
                            'text-danger bg-soft-danger': !user.isAccountApproved || !user.isAccountVerified
                        }">
                          {{ user.isAccountApproved && user.isAccountVerified? 'Da' : 'Ne' }}
                        </span>
                      </td>
                      <td>{{ formatDate(user.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }} <a class="alert-link" @click.prevent="resetFilters">{{ translations.resetFilters }}</a>.
                </div>
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-stretch">
                    <div
                      class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                    >
                      <select
                        class="form-control select-style-1 bulk-action"
                        name="bulk-action"
                        v-model="bulkAction"
                        style="min-width: 170px"
                      >
                        <option value="bulkAction">Bulk Actions</option>
                        <option value="delete">Delete</option>
                      </select>

                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
                        {{ translations.apply }}
                      </button>
                      
                    </div>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" :pagination-props="paginationProps" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header"><strong>{{ translations.deleteSelected }}</strong></h5>
      <div slot="body">
        <span v-html="modalText">
        </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleBulkAction" data-bs-dismiss="modal">
              {{ translations.yes }}
            </button>
            <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { pager, translations } from '@/mixins';
import Pagination from '@/components/shared/Pagination.vue';
import Modal from '@/components/shared/modal/Modal.vue';

export default {
  components: { Treeselect, Pagination, Modal },
  name: 'Users',
  mixins: [pager, translations],
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getUsers',
      deleteActionName: 'deleteUsers',
      bulkActionName: 'deleteUsers',
      b2bOrb2c: query?.b2b ? 'b2b' : query?.b2c ? 'b2c' : null,
    };
  },
  computed: {
    list() {
      return this.$store.getters.getUsers;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
    b2bOrb2cOptions() {
      return [
        { id: 'b2b', label: 'B2B' },
        { id: 'b2c', label: 'B2C' },
        { id: 'all', label: 'Sve' },
      ];
    },
    paginationProps() {
      return {
        b2b: this.b2bOrb2c === 'b2b' ? true : null,
        b2c: this.b2bOrb2c === 'b2c' ? true : null,
      };
    },
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditUser', params: { id } });
    },
    getUsers() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: 1,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
  watch: {
    b2bOrb2c() {
      this.getUsers();
    },
  },
};
</script>

<style lang="scss">
.alert-link {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>

<style lang="scss">
.vue-treeselect {
  height: 47px;
}

.vue-treeselect__control {
  height: 47px;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}

.vue-treeselect__value-container {
  height: 47px;
}
</style>